/**
 * Logo institucional DelivAI (ficheiro estático).
 * Ficheiro atual: `public/New LOGO.png` — o CRA copia `public/` para a raiz do `build/` em `npm run build`.
 */
import { coercePayTypesObject } from "./payTypes";

export const DELIVAI_PUBLIC_BRAND_LOGO = "/New LOGO.png";

/** Segunda opção (nome antigo na pasta public). */
export const DELIVAI_PUBLIC_BRAND_LOGO_FALLBACK = "/DelivAI Logo.png";

/** Terceira opção (asset legado mínimo). */
export const DELIVAI_PUBLIC_BRAND_LOGO_FALLBACK_LEGACY =
  "/delivai-assistant-intelligence-logo.png";

/**
 * URL do logotipo salvo em pay_types.logo_public (mesmo fluxo das imagens do cardápio).
 */
export function getLogoPublicUrlFromPayTypes(payTypes: unknown): string {
  const url = coercePayTypesObject(payTypes)?.logo_public?.url;
  return typeof url === "string" && url.trim() ? url.trim() : "";
}

/** Logo da loja: pay_types.logo_public, senão primeira imagem do cardápio. */
export function getCompanyLogoUrl(customer: unknown): string {
  if (!customer || typeof customer !== "object") return "";
  const c = customer as Record<string, unknown>;
  const fromPay = getLogoPublicUrlFromPayTypes(c.pay_types ?? c.payment_methods);
  if (fromPay) return fromPay;
  const imgs = c.imagem_cardapio ?? c.menu_images;
  if (Array.isArray(imgs) && imgs[0] && typeof imgs[0] === "object") {
    const url = (imgs[0] as { url?: string }).url;
    if (typeof url === "string" && url.trim()) return url.trim();
  }
  return "";
}
